import { Component, Input, Output, EventEmitter } from '@angular/core';

interface JiraIssue {
  id: string;
  key: string;
  fields: {
    summary: string;
    description?: string;
    status: {
      name: string;
    };
    issuetype?: {
      name: string;
    };
    priority?: {
      name: string;
    };
    epic?: {
      key: string;
      summary: string;
      color?: string;
    };
    parent?: {
      key: string;
      fields: {
        summary: string;
        issuetype: {
          name: string;
        };
      };
    };
    reporter?: {
      displayName: string;
      emailAddress: string;
    };
    assignee?: {
      displayName: string;
      emailAddress: string;
    };
  };
}

@Component({
  selector: 'app-issue-card',
  templateUrl: './issue-card.component.html',
  styleUrls: ['./issue-card.component.scss'],
})
export class IssueCardComponent {
  @Input() issue!: JiraIssue;
  @Input() creatingNewIssue = false;

  @Output() summaryUpdate = new EventEmitter<{
    event: FocusEvent;
    issue: JiraIssue;
  }>();
  @Output() summaryKeydown = new EventEmitter<KeyboardEvent>();
  @Output() summaryPaste = new EventEmitter<ClipboardEvent>();
  @Output() deleteIssue = new EventEmitter<JiraIssue>();
  @Input() getSummaryError!: (issue: JiraIssue) => string | null;
  @Input() getEpicDetails!: (
    issue: JiraIssue
  ) => { key: string; summary: string; color: string } | null;

  onSummaryUpdate(event: FocusEvent): void {
    this.summaryUpdate.emit({ event, issue: this.issue });
  }

  onSummaryKeydown(event: KeyboardEvent): void {
    this.summaryKeydown.emit(event);
  }

  onSummaryPaste(event: ClipboardEvent): void {
    this.summaryPaste.emit(event);
  }

  onDeleteIssue(): void {
    this.deleteIssue.emit(this.issue);
  }

  getSummaryErrorForIssue(): string | null {
    return this.getSummaryError(this.issue);
  }

  getEpicDetailsForIssue(): {
    key: string;
    summary: string;
    color: string;
  } | null {
    return this.getEpicDetails(this.issue);
  }
}
